export const SET_PAGE = 'set/PAGE'
export const SET_READY = 'set/READY'
export const SET_TYPES = 'set/TYPES'
export const SET_OPTIONS = 'set/OPTIONS'
export const ADD_LOADING = 'add/LOADING'
export const REMOVE_LOADING = 'remove/LOADING'
